// extracted by mini-css-extract-plugin
export default {"headerSearch":"index_headerSearch__mzFFp","inputContainer":"index_inputContainer__dJ5ju","searchInputContainer":"index_searchInputContainer__AnQwF","input":"index_input__afFpf"};